import { useCallback, useMemo } from 'react';
import { useNavComponentsManager } from './useNavComponentsManager';
export const useCapability = name => {
  const {
    subscribe: handleSubscribe
  } = useNavComponentsManager();
  const subscribe = useCallback(cb => {
    return handleSubscribe(name, cb);
  }, [handleSubscribe, name]);
  const asPromise = useCallback(() => {
    return new Promise(resolve => {
      const unsubscribe = handleSubscribe(name, args => {
        resolve(args);
        unsubscribe();
      });
    });
  }, [handleSubscribe, name]);
  return useMemo(() => ({
    subscribe,
    asPromise
  }), [asPromise, subscribe]);
};